import type {CloudFunctionsService} from '../types/services'
import {createContext, useContext} from 'react'

export const CloudFunctionsServiceContext = createContext<CloudFunctionsService | null>(null)

export const useCloudFunctionsService = () => {
  const service = useContext(CloudFunctionsServiceContext)
  if (!service) {
    throw new Error('CloudFunctionsServiceContext requires a Cloud Functions service.')
  }
  return service
}
